module.exports = "footer {\n    position: fixed;\n    left: 0;\n    bottom: 0;\n    width: 100%;\n    height: 5em;\n    text-align: center;\n    /*border-top: 1px solid rgba(0,0,0,.1);*/\n    /*background-color: rgba(0,0,0,.04);*/\n    border-top: 1px solid #dcdcdc;\n    background-color: #f5f5f5;\n    padding: 10px;\n}\n\nfooter {\n    color: #333333;\n    font-size: 14px;\n    font-family: \"ProximaNova\", \"Arial\", sans-serif;\n    font-weight: normal;\n    line-height: 1.42857143;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/core/components/footer/footer.component.css
// module id = ./src/app/core/components/footer/footer.component.css
// module chunks = main